export class GetOverallLevelDescriptions {
  static readonly type = "[OverallLevelDescriptions] Get overall descriptions";
}
